import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '@/contexts/auth-context'

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, isSessionValid, loading } = useAuth()
  const location = useLocation()

  // Block ONLY on the initial auth bootstrap. `loading` stays true until the
  // first token validation finishes, so no protected content flashes before we
  // know the session is valid.
  //
  // Deliberately do NOT block on `validationInProgress`: background
  // re-validations toggle it repeatedly, and each toggle would flip this guard
  // spinner<->children, unmounting and remounting the entire shell below
  // (OrganizationProvider, DashboardLayout, the active page) and re-firing all
  // of their queries. Keeping children mounted during re-validation is what
  // makes the shell mount once. If a re-validation fails, `isSessionValid`
  // flips to false and the redirect below still kicks in.
  if (loading) {
    return <div className="flex items-center justify-center min-h-screen">
      <div className="animate-pulse">Loading...</div>
    </div>
  }

  // If session is not valid or no user, redirect to login
  if (!isSessionValid || !user) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  // Session is valid and user exists, render protected content
  return <>{children}</>
}